<div>
  <audio
    [src]="safeUrl || ''"
    #audioElement
    preload="auto"
    (timeupdate)="onTimeUpdate($event)"
  ></audio>

  <div *ngIf="duration > 0 && url.length">
    <div class="form-group vocal-form" [ngStyle]="styles">
      <button
        class="btn-pause"
        [ngClass]="{ 'in-pause': paused }"
        (click)="paused ? play() : pause()"
      ></button>
      <div class="progress-container">
        <div
          class="progress-bar"
          [style.width.%]="progressbarWitdh(progressBarValue,duration)"
        ></div>
      </div>
      <span class="time">{{ formatTime((timeCountValue/1000).toFixed(2)) }}</span>
    </div>
  </div>
</div>
